import { render, staticRenderFns } from "./ServiceFormStep5.vue?vue&type=template&id=04bb10b6&"
import script from "./ServiceFormStep5.vue?vue&type=script&lang=js&"
export * from "./ServiceFormStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports